/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { RequestCategory } from '@src/app/model/RequestCategory';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestCategoriesService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl() {
        return this.getAjaxPath('crm/categories');
    }

    protected cache: RequestCategory[];
    protected typeString = 'Request Category';

    getAvailable(): Observable<RequestCategory[]> {
        return this.http.get(this.baseUrl + '/available') as Observable<RequestCategory[]>;
    }
}
